/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useTagList } from '@api/hooks';

import SearchableEntitySelect from '../SearchableEntitySelect';

const ArticleTagSelect = ({ placeholder = 'Start typing a content tag...', ...props }) => (
  <SearchableEntitySelect placeholder={placeholder} useList={useTagList} formatLabel={({ tag }) => tag} {...props} />
);

export default ArticleTagSelect;
